/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Page_TitleInputs */



/**
* | output |
* | --- |
* | "Profile" |
*
* @param {Profile_Page_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_page_title = /** @type {((inputs?: Profile_Page_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Page_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Profil")
	if (locale === "es") return /** @type {LocalizedString} */ ("Perfil")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Perfil")
	if (locale === "it") return /** @type {LocalizedString} */ ("Profilo")
	return /** @type {LocalizedString} */ ("Profile")
});